import Icon from '../../components/Icon.vue'

Icon.register({"brands/red-river":{"width":448,"height":512,"paths":[{"d":"M353.2 32H94.8C42.4 32 0 74.4 0 126.8V385.2C0 437.6 42.4 480 94.8 480H353.2C405.6 480 448 437.6 448 385.2V126.8C448 74.4 405.6 32 353.2 32zM144.9 200.9V257.2C144.9 284.2 123 306.1 96 306.1V151.9C96 138.7 106.7 128 119.9 128H274.1C274.1 155 252.2 176.9 225.2 176.9H168.9C156.6 176.3 144.3 188.5 144.9 200.9zM321.2 272.9H264.9C252.6 272.3 240.3 284.5 240.9 296.9V353.2C240.9 380.2 219 402.1 192 402.1V247.9C192 234.7 202.7 224 215.9 224H370.1C370.1 251 348.2 272.9 321.2 272.9z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/red-river.js
// module id = null
// module chunks = 